import React from 'react';
const PackagingHeader: React.FC = () => {
  return null;
};

export default PackagingHeader;
